import React from 'react';
import {
  WidgetCard,
  IconBox,
  Header,
  HeaderRow,
  StatRow,
  StatLabel,
  StatValue,
  DividerLine,
  ButtonBox
} from './styles';
import InsightsIcon from '@mui/icons-material/Insights';
import { Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/* helper to format "Last Batch Added" as:
   - "Today · 7:00 PM"
   - "Yesterday · 7:00 PM"
   - "Aug 11, 2025 · 7:00 PM" (if older) */
const formatRecentDate = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  const now = new Date();

  const sameDay = d.toDateString() === now.toDateString();

  const yest = new Date(now);
  yest.setDate(now.getDate() - 1);
  const isYest = d.toDateString() === yest.toDateString();

  const time = d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });

  if (sameDay) return `Today · ${time}`;
  if (isYest) return `Yesterday · ${time}`;
  return `${d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })} · ${time}`;
};

const StatsWidget = ({
  totalBatches = null,
  lastBatchAddedAt = null,
  activeAlerts = null,
  newAlertsToday = null,
  inventoryHref = '/inventory',
  alertsHref = '/alerts',
}) => {
  return (
    <WidgetCard>
      {/* ─── icon + heading ─── */}
      <HeaderRow>
        <IconBox sx={{background:'linear-gradient(-45deg, #526af4, #3ec8e0)'}}>
          <InsightsIcon />
        </IconBox>
        <Header>Quick Stats</Header>
      </HeaderRow>
      <DividerLine sx={{ marginBottom: '8px' }} />

      {/* ─── stats ─── */}
      <StatRow>
        <StatLabel>Total Batches</StatLabel>
        <StatValue sx={{ fontSize: '1.5rem' }}>
          {totalBatches ?? '—'}
        </StatValue>
      </StatRow>

      <StatRow>
        <StatLabel>Last Batch Added</StatLabel>
        <StatValue sx={{ color: 'darkgrey', fontSize: '0.9rem' }}>
          {formatRecentDate(lastBatchAddedAt)}
        </StatValue>
      </StatRow>

      <StatRow>
        <StatLabel>Active Alerts</StatLabel>
        <StatValue sx={{ color: '#ff0000c2' }}>
          {activeAlerts ?? '—'}
        </StatValue>
      </StatRow>

      <StatRow>
        <StatLabel>New Alerts Today</StatLabel>
        <StatValue sx={{ color: '#ff0000c2' }}>
          {newAlertsToday ?? '—'}
        </StatValue>
      </StatRow>

      <DividerLine />

      {/* ─── actions ─── */}
      <ButtonBox>
        <Button
          variant="contained"
          component={RouterLink}
          to={inventoryHref}   
          sx={{ backgroundColor: '#1976d2', fontWeight: '600', textTransform: 'capitalize', borderRadius: '10px', boxShadow: 'none' }}
        >
          View Inventory
        </Button>
        <Button
          variant="contained"
          component={RouterLink}
          to={alertsHref}   
          color="error"
          sx={{ backgroundColor: '#ff0000c2', fontWeight: '600', textTransform: 'capitalize', borderRadius: '10px', boxShadow: 'none' }}
        >
          View Alerts
        </Button>
      </ButtonBox>
    </WidgetCard>
  );
};

export default StatsWidget;
